import { Link, useLocation } from 'react-router-dom';
import SmartImg from './SmartImg.jsx';
import { SITE_IMAGES } from '../data/siteImages.js';
import { getHeroContent } from '../data/heroContent.js';

export default function Hero() {
  const { pathname } = useLocation();
  const content = getHeroContent(pathname);

  return (
    <section className="hero">
      <div className="hero-media" role="img" aria-label={content.ariaLabel}>
        <SmartImg
          className="hero-photo"
          src={SITE_IMAGES.heroBackground}
          alt=""
          width={1920}
          height={1080}
          fetchPriority="high"
        />
        <div className="hero-overlay" aria-hidden="true" />
      </div>
      <div className="hero-content" key={pathname}>
        <p className="eyebrow">{content.eyebrow}</p>
        <h1>{content.title}</h1>
        <p className="lede">{content.lede}</p>
        <div className="hero-actions">
          {content.actions.map((action, i) => {
            if (action.href) {
              return (
                <a
                  key={`${action.href}-${i}`}
                  href={action.href}
                  className={`btn btn-${action.variant}`}
                  {...(action.external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
                >
                  {action.label}
                </a>
              );
            }
            return (
              <Link key={`${action.to}-${i}`} className={`btn btn-${action.variant}`} to={action.to}>
                {action.label}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}
